import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [ 

{
  id: 'process',
  title: 'Process',
  translate: 'Process',
  type: 'item',
  icon: 'settings',
  url: '/process-pages/process-lp'
},
  {
    id: 'forms',
    title: 'Forms',
    translate: 'Forms',
    type: 'item',
    icon: 'file-text',
    url: '/input-config-pages/forms-lp'
  },
  {
    id: 'publish-process',
    title: 'Publish Process',
    translate: 'Publish Process',
    type: 'item',
    icon: 'globe',
    url: '/publish-process/publish-process-lp'
  },
  {
    id: 'template',
    title: 'Templates',
    translate: 'Templates',
    type: 'item',
    icon: 'layers',
    url: '/template/templates-lp'
  },
  {
    id: 'microflows',
    title: 'Microflows',
    translate: 'Microflows',
    type: 'item',
    icon: 'git-merge',
    url: '/microflows/microflow-lp'
  },
  {
    id: 'workflow',
    title: 'workflowflow',
    translate: 'Workflow',
    type: 'item',
    icon: 'briefcase',
    url: '/workflow-pages/workflow-lp'
  },
  {
    id: 'instance-config',
    title: 'Instance Config',
    translate: 'Instance Config',
    type: 'item',
    icon: 'tool',
    url: '/instance-config-pages/instance-config-lp'
  },
  {
    id: 'api-user-config',
    title: 'Api User Master',
    translate: 'Api User Master',
    type: 'item',
    icon: 'user',
    url: '/user-api-master-pages/user-api-master'
  },
  {
    id: 'integration-url-config',
    title: 'Integration Url Master',
    translate: 'Integration Url Master',
    type: 'item',
    icon: 'link',
    url: '/integration-url-master-pages/integration-url-master'
  },
  {
    id: 'OCR Master',
    title: 'OCR Master',
    translate: 'OCR Master',
    type: 'item',
    icon: 'cpu',
    url: '/ocr-Master/ocr-lp'
  },
 
]
